<template>
  <banner
    :icon="!hideIcon ? 'fa-exclamation-triangle' : ''"
    :title="title"
    class="danger"
  >
    <slot></slot>
  </banner>
</template>
<script>
import Banner from "./Banner.vue";

export default {
  components: { Banner },
  props: {
    title: {
      type: String,
      required: false,
      default: "",
    },
    hideIcon: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped>
@use "sass:color";
@import "@/_css/variables";

.danger {
  border-color: $red !important;
  color: $red !important;
  background-color: color.adjust($red, $lightness: 50%) !important;
}
</style>
